import React, { useEffect } from 'react';
import './campos-item-menu-footer.component.scss';
import { Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItemMenusModel, ItensComIconesModel } from '../../models/footer.model';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { CONSTANTS } from '../../constants/constants';
import { SalvarPainelService } from '../../services/salvar-painel.service';

type CamposMenuProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemMenuFooter?: ItemMenusModel;
  index?: number;
}

function CamposItemMenuFooterComponent(props: CamposMenuProps) {

  const { value: textoInputText, bind: bindTextoInputText, setValue: setTextoInputText } = useInput(props.itemMenuFooter?.texto);
  const { value: urlInputText, bind: bindUrlInputText, setValue: setUrlInputText } = useInput(props.itemMenuFooter?.url);
  const [tipoInput, setTipoInput] = React.useState(props.itemMenuFooter?.tipo);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      texto: textoInputText,
      url: urlInputText,
      tipo: tipoInput,
      id: props.itemMenuFooter?.id
    });
  };

  return (
    <section className="campos-item-menu-footer">
      <div className="campo w50">
        <TextField {...bindTextoInputText} label="Texto" />
      </div>

      <div className="campo w50">
        <TextField {...bindUrlInputText} label="URL" />
      </div>

      <div className="campo">
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">Tipo</FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={tipoInput}
            onChange={(el) => setTipoInput(el.currentTarget.value)}
          >
            <FormControlLabel value={CONSTANTS.TIPO_BOTAO.LINK_INTERNO} control={<Radio />} label="Link interno" />
            <FormControlLabel value={CONSTANTS.TIPO_BOTAO.LINK_EXTERNO} control={<Radio />} label="Link externo" />
          </RadioGroup>
        </FormControl>
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemMenuFooter?.id)}><DeleteIcon /> Remover item</Button>
      </div>
    </section>
  );
}

export default CamposItemMenuFooterComponent;
